import React from 'react';
import Helmet from 'react-helmet';
import Home from '../../container/Home';
// import Wrapper from 'components/wrapper';
import Head from '../../component/libs/Head';

export default (...routeConfig) => {
  const [route] = routeConfig;
  const { history, is404 = false } = route;

  return (
    <>
      <Head {...routeConfig} />
      <Helmet>
        <title>Styli Account</title>
      </Helmet>
      {/* <Wrapper> */}
      <Home history={history} is404={is404} />
      {/* </Wrapper> */}
    </>
  );
};
